import './Selecter.css';
import PropTypes from 'prop-types';

import { useState, useEffect } from 'react';
import Select, { components } from 'react-select';

const Selecter = ({
    options,
    defaultValue,
    isMenuOpen,
    onValueChange,
    onValueClear
}) => {
    const [hasValue, setHasValue] = useState(false);

    useEffect(() => {
        setHasValue(!!defaultValue);
    }, [defaultValue]);

    const onChange = (value, event) => {
        if (event.action === 'select-option') {
            setHasValue(true);
            onValueChange(value.value);
        } else if (event.action === 'clear') {
            let clearedField = event.removedValues[0].value;
            setHasValue(false);
            onValueClear(clearedField);
        }
    };

    return (
        <Select
            menuIsOpen={isMenuOpen}
            className="pb-select-wrapper"
            options={options}
            classNamePrefix="pb-select"
            placeholder="Select Column"
            isClearable
            onChange={onChange}
            defaultValue={defaultValue}
            value={defaultValue}
            isSearchable={false}
            openMenuOnClick={!hasValue}
            components={{
                DropdownIndicator: hasValue
                    ? null
                    : components.DropdownIndicator
            }}
        />
    );
};

Selecter.propTypes = {
    options: PropTypes.arrayOf(PropTypes.shape({})),
    defaultValue: PropTypes.shape({}),
    onValueChange: PropTypes.func,
    onValueClear: PropTypes.func,
    isMenuOpen: PropTypes.bool
};

export default Selecter;
